import { FC } from "react";
import { HStack, Stack, Text } from "@chakra-ui/react";

import { IScheduleItem } from "../../../../../api/schedule/types.ts";
import { formatDate, formatPriceWithoutZeros, isStringWithNumber } from "../../../../../utils";
import { MainPagePaymentScheduleCommission } from "./MainPagePaymentScheduleCommission";
import { MainPagePaymentScheduleAddPaymentButton } from "./MainPagePaymentScheduleAddPaymentButton";

interface Props {
  nearestPayment: IScheduleItem | undefined;
}

export const MainPagePaymentScheduleNearest: FC<Props> = ({ nearestPayment }) => {
  const nearestAmount = isStringWithNumber(nearestPayment?.total)
    ? formatPriceWithoutZeros(Number(nearestPayment?.total))
    : "";

  const nearestDate = nearestPayment?.date
    ? formatDate(new Date(nearestPayment.date), {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })
    : "";
  const nearestText = nearestDate ? `Ближайший платёж ${nearestDate}` : "";
  const paymentStatus = nearestPayment?.status === "PLANNED" ? "Ожидаем платеж" : "";

  return (
    <Stack spacing={0} mt="7px">
      <Text w="100%" fontSize="sm" mb="5px">{nearestText}</Text>

      <HStack justifyContent="space-between">
        <Text fontFamily="Normalidad Medium Var" fontSize="20px" variant="brand">
          {nearestAmount}
        </Text>

        {paymentStatus && (
          <Text variant="gray" px="8px" py="2px" fontSize="10px" bg="gray.50" borderRadius="35px">
            {paymentStatus}
          </Text>
        )}
      </HStack>

      <MainPagePaymentScheduleCommission paymentAmount={nearestPayment?.total} />

      <MainPagePaymentScheduleAddPaymentButton />
    </Stack>
  );
};
